import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Badge({
  children,
  className,
  tone = 'slate',
}: {
  children: ReactNode;
  className?: string;
  tone?: 'slate' | 'green' | 'yellow' | 'red' | 'blue';
}) {
  const tones = {
    slate: 'bg-slate-100 text-slate-700',
    green: 'bg-green-100 text-green-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    red: 'bg-red-100 text-red-800',
    blue: 'bg-blue-100 text-blue-800',
  } as const;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
